module.exports = `${require.publicPath}tenant-admin.56402780.png`;